import { useMutation } from '@tanstack/react-query';
import MessagesClient from 'flux/clients/messages';
import lscache from 'lscache';
import { useState } from 'react';
import { RequestPersonalizedOfferType } from 'reusable-components/forms/ContactHostForm/RequestPersonalizedOfferForm/types/types';
import convertTo24HourFormatObject from 'utils/timeHelpers/convertTo24HourFormatObject';

export const useSendOfferRequestToHosts = ({ source }) => {
  const [status, setStatus] = useState('idle'); // Initialize status as 'idle'

  const mutation = useMutation(
    async ({ hostIds }: { hostIds: string[] }) => {
      const formData = lscache.get('personalizeOfferForm');

      const timeObject = convertTo24HourFormatObject(formData.time);

      const nrOfAdults = parseInt(formData.adults, 10);
      const nrOfChildren = parseInt(formData.children, 10);

      const offerRequest: Partial<RequestPersonalizedOfferType> = {
        body: formData.request,
        date: `${formData.date}T${timeObject.hour}:${timeObject.minute}`,
        number_of_people: nrOfAdults + nrOfChildren,
        number_of_children: nrOfChildren,
        requestType: 'NEWCUSTOMTRIP',
        experience_id: formData.experienceId,
        source,
        viaSentToOtherHosts: true,
        turnstile_token: formData.turnstile_token,
      };

      const requests = hostIds.map((hostId) => {
        const request = { to: hostId, ...offerRequest };
        return MessagesClient.sendOfferRequest(request);
      });
      const responses = await Promise.allSettled(requests);
      return responses;
    },
    {
      onMutate: () => {
        setStatus('loading');
      },
      onSuccess: () => {
        setStatus('success');
      },
      onError: () => {
        setStatus('error');
      },
    },
  );

  const triggerSendOfferRequest = ({ hostIds }) => {
    if (hostIds.length > 0) {
      mutation.mutate({ hostIds });
    } else {
      console.error('Please provide an array of hosts');
    }
  };

  return { triggerSendOfferRequest, status };
};
